import { UserDataT } from "../models/models";
import { UserSettingsT } from "../models/models";
import apiRequest from "../utils/ApiRequest/apiRequest";
import { ApiResponseObjectT } from "./models";

const RecoverPasswordUserRequestReactApiRequest = async (
  payload: RecoverPasswordUserRequestReactApiRequestT
) => {
  const response = await apiRequest(
    "Users",
    "RecoverPasswordUserRequestReact",
    payload
  );

  return response;
};

const GetUserUsedStorageApiRequest = async () => {
  const response = await apiRequest("Users", "GetUserUsedStorage");

  return response;
};

const APIExternalLoginApiRequest = async (
  body: APIExternalLoginApiRequestPayloadT
) => {
  const response = await apiRequest(
    "Users",
    "APIExternalLogin",
    body,
    "POST",
    null,
    "application/json",
    null,
    false,
    true
  );

  return response;
};

const GetUserSettingsApiRequest = async (): Promise<
  ApiResponseObjectT<UserSettingsT>
> => {
  const response = await apiRequest("Users", "GetUserSettings");

  return response;
};

const UpdateSubUsersMFAApiRequest = async (
  payload: UpdateSubUsersMFAApiRequestPayloadT
) => {
  const response = await apiRequest(
    "Users",
    "UpdateSubUsersMFA",
    payload,
    "POST"
  );

  return response;
};

const MVCLoginApiRequest = async (
  reactAuth: MVCLoginApiRequestPayloadT
): Promise<ApiResponseObjectT<MVCLoginApiRequestResponseT>> => {
  const res = await apiRequest(
    "Users",
    "MVCLogin",
    reactAuth,
    "POST",
    "application/json"
  );

  return res;
};

const GetOrganizationTokenRequest = async (): Promise<
  ApiResponseObjectT<string>
> => {
  const response = await apiRequest("Users", "GetOrganizationToken");

  return response;
};

export type MVCLoginApiRequestPayloadT = {
  data: string;
  status: string;
  token_type: string;
  expires_in: number;
  loginDate: string;
};

export type MVCLoginApiRequestResponseT = {
  UserData: UserDataT;
  RedirectUrl: string | null;
  IsRegistered: boolean;
  Authentication: Record<string, any> | null;
  nowDate: string;
  BearerToken: string | null;
};

export type APIExternalLoginApiRequestPayloadT = {
  OAuthProvider: string;
  OAuthAccessToken: string;
  Url: string;
  referer?: string;
  isInvitationPage?: boolean;
};

export type RecoverPasswordUserRequestReactApiRequestT = {
  userEmail: string;
  didRecaptcha: boolean;
  culture: string;
  recaptchaResponse: string;
  captchaServiceName: "google" | "cloudflare";
};

export type UpdateSubUsersMFAApiRequestPayloadT = {
  EnableMFA: boolean;
};

export {
  RecoverPasswordUserRequestReactApiRequest,
  GetUserUsedStorageApiRequest,
  APIExternalLoginApiRequest,
  MVCLoginApiRequest,
  GetOrganizationTokenRequest,
  GetUserSettingsApiRequest,
  UpdateSubUsersMFAApiRequest,
};
